/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NearMissTypeDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: NearMissTypeDefinitionDto.source;
    label?: string;
}

export namespace NearMissTypeDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
